module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-og-image-3a595a3a54d4f786023f8968f80871df.jpg";